<template>
    <section class="about-section text-center bg-black" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 mx-auto">
                    <h2 class="text-white mb-4">{{ t('about.heading') }}</h2>
                    <p class="text-white-50 text-center" v-html="t('about.body')"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { useI18n } from 'vue-i18n'
    const { t } = useI18n()
</script>